import { log2 } from "./log2";
import CONFIG from "../config/config";
import moment from "moment";

const showChildrenState = {};
const log = log2("Menu");
export default (that) => {
    return [
        {
            superAdminPageKey: "admin-reports",
            title: that.$t("message.adminReports"),
            path: "/admin-reports",
            icon: "admin-reports",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "cluster-dashboard",
            title: that.$t("message.dashboard"),
            path: "/cluster-dashboard",
            icon: "cluster-dashboard",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },

        {
            superAdminPageKey: "announcements",
            title: that.$t("announcements.menu"),
            path: "/announcements",
            icon: "clipboard-list",
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "coupons",
            title: that.$t("coupon.coupons"),
            path: "/coupons",
            icon: "Coupon",
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "invoices",
            title: that.$t("billing.invoices"),
            path: "/invoices",
            icon: "CreditCard",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "admin-users",
            title: that.$t("adminUser.adminUsers"),
            path: "/admin-users",
            icon: "users",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "sites",
            title: that.$t("message.sites"),
            path: "/sites",
            icon: "site",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "global-settings",
            title: that.$t("message.globalSettings"),
            path: "/global-settings",
            icon: "cogs",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "plan-management",
            title: that.$t("message.planManagement"),
            path: "/plans",
            icon: "SubscriptionIcon",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            superAdminPageKey: "error-reports",
            title: that.$t("message.feedback"),
            path: "/ErrorReports",
            icon: "cogs",
            antIcon: "bug",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-chat",
            title: that.$t("message.CHAT"),
            path: "/chat",
            icon: "ChatIcon",
            permission: "chat.get",
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-chatbot",
            title: "ChatBot",
            path: "/chatbot",
            icon: "chatbot",
            permission: [
                "chatbot.view",
                "chatbot.stories.view",
                "chatbot.templates.view",
                "chatbot.aitemplates.view",
                "chatbot.integrations.view",
                "chatbot.archive.view",
                "chatbot.entities.view",
                "chatbot.reports.view",
                "chatbot.training.view",
            ],
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "automations",
            title: that.$t("automation.automations"),
            path: "/automations",
            icon: "AutomationIcon",
            permission: ["automation.get"],
            showChildren: false,
            enabled: CONFIG.AUTOMATION_ENABLED,
            isNew: true,
        },
        {
            superAdminPageKey: "tables",
            title: that.$t("tables.tables"),
            path: "/tables",
            antIcon: "table",
            permission: ["table.get"],
            showChildren: false,
            enabled: CONFIG.AUTOMATION_ENABLED,
            isNew: true,
        },
        {
            superAdminPageKey: "customer-visitors",
            title: that.$t("billing.Contacts"),
            path: "/visitors",
            icon: "VisitorsIcon",
            permission: ["visitor.list.view", "tags.update", "tags.delete", "tags.create"],
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-mails",
            title: that.$t("chatbotv2.attr.email"),
            path: "/mails",
            icon: "MailIcon",
            permission: "mail.read",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.calendarModule"),
            path: `/calendar/d/${moment().format().split("T")[0]}`,
            icon: "CalendarIcon",
            permission: "calendar.read",
            showChildren: false,
            enabled: true,
            superAdminPageKey: "customer-calendar",
        },
        {
            superAdminPageKey: "customer-tasks",
            title: that.$t("message.taskModule"),
            path: "/tasks",
            icon: "TaskIcon",
            permission: ["task.read"],
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-forms",
            title: that.$t("form.forms"),
            path: "/form",
            icon: "FormIcon",
            permission: ["form.get"],
            showChildren: false,
            enabled: CONFIG.FORM_SERVICE_ENABLED,
            isNew: true,
        },
        {
            superAdminPageKey: "customer-ticket",
            title: that.$t("message.ticket"),
            path: "/ticket",
            icon: "ticket",
            permission: ["offlineSupportRequest.get", "ticket"],
            showChildren: false,
            enabled: true,
        },
        {
            superAdminPageKey: "customer-archive",
            title: that.$t("message.archive"),
            path: "/archives",
            icon: "ArchiveIcon",
            permission: "archives.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.tags"),
            path: "/tags",
            icon: "tags",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.offlineSupportRequests"),
            path: "/offline-support-requests",
            icon: "offline-support",
            permission: "offlineSupportRequest.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.roles"),
            path: "/roles",
            icon: "masks",
            permission: "role.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.bannedVisitors"),
            path: "/banned-visitors",
            icon: "user-slash",
            permission: "bannedVisitor.view",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.welcomeMessages"),
            path: "/system-messages",
            icon: "hand-paper",
            permission: "welcome.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.catalogCategories"),
            path: "/catalog",
            icon: "Catalog",
            permission: "catalog.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.bannedWords"),
            path: "/forbidden-inputs",
            icon: "ban",
            permission: "bannedWord.get",
            showChildren: false,
            enabled: false,
        },
        /*{
            superAdminPageKey: "customer-billing",
            title: that.$t("billing.billingPlanSettings"),
            path: "/billing",
            icon: "CreditCard",
            permission: "billing.read",
            showChildren: false,
            enabled: true,
        },*/
    ];
};

export const toggleShowChildren = (path) => {
    log("toggleShowChildren called", path);
    if (showChildrenState[path] !== undefined) {
        showChildrenState[path] = !showChildrenState[path];
    } else {
        showChildrenState[path] = true;
    }
};
